import { render, staticRenderFns } from "./MatomoLink.vue?vue&type=template&id=90662fc2&"
import script from "./MatomoLink.vue?vue&type=script&lang=js&"
export * from "./MatomoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports